import React from 'react'
import {useIntl} from 'react-intl'
import {Link as RouteLink} from 'react-router-dom'
import {Button, Divider, Stack} from '@salesforce/retail-react-app/app/components/shared/ui'
import {ctaListStyle} from './index.style'
import {CavHelpIcon, InvertedLocatorIcon, OrderIcon} from '../icons'

const CTAList = () => {
    const {formatMessage} = useIntl()

    const closeLoginModal = () => {
        const authCloseTrigger = document.querySelector('#auth-modal-close-trigger')
        if (authCloseTrigger) {
            authCloseTrigger.click()
        }
    }
    const openTrackModal = () => {
        const trackOrderTrigger = document.querySelector('#header-track-order-link')
        if (trackOrderTrigger) {
            trackOrderTrigger.click()
        }
    }

    const handleTrackOrderClick = (e) => {
        e?.preventDefault()
        e?.stopPropagation()
        openTrackModal()
        closeLoginModal()
    }
    return (
        <Stack sx={ctaListStyle}>
            <Divider />
            <Button
                variant="ghost"
                width="full"
                leftIcon={<OrderIcon className="order-icon" />}
                onClick={handleTrackOrderClick}
            >
                {formatMessage({
                    id: 'login.link.track_my_orders',
                    defaultMessage: 'Track My Order'
                })}{' '}
                {'>>'}
            </Button>
            <Divider />
            <Button
                as={RouteLink}
                variant="ghost"
                width="full"
                leftIcon={<CavHelpIcon className="help-icon" />}
                to="/contactus"
                onClick={closeLoginModal}
            >
                {formatMessage({
                    id: 'login.link.contact_us',
                    defaultMessage: 'Contact Us'
                })}{' '}
                {'>>'}
            </Button>
            <Divider />
            <Button
                as={RouteLink}
                variant="ghost"
                width="full"
                leftIcon={<InvertedLocatorIcon className="locator-icon" />}
                to="/storelocator"
                onClick={closeLoginModal}
            >
                {formatMessage({
                    id: 'login.link.find_a_store',
                    defaultMessage: 'Find A Store'
                })}{' '}
                {'>>'}
            </Button>
        </Stack>
    )
}

export default CTAList
